import { Container } from "react-bootstrap";
import { Buildings, GraphUp, People, FileEarmarkBarGraph, Receipt } from "react-bootstrap-icons";
import { Outlet, useLoaderData, useLocation } from "react-router-dom";
import { PageTitle } from "./Controls/PageTitle";
import { Operator } from "./Data/ApiTypes";
import { CollapsibleSidebar } from "./Controls/CollapsibleSidebar";
import { CollapsibleMenuItem } from "./Controls/CollapsibleMenuItem";
import { useAtom } from "jotai";
import { authAtom } from "./Data/Atoms";
import { isAdminRole } from "./helpers/RoleManager";
import { useAuthorization } from "./hooks/useAuthorization";

export function AppOperator() {
    const loc      = useLocation();
    const operator = useLoaderData() as Operator;
    const [auth]   = useAtom(authAtom);
    const { canAccessPath } = useAuthorization();

    const roles = auth.account?.roles ?? [];
    const isFacilityUserOnly = !isAdminRole(roles) && roles.includes('FacilityUser');
    const canAccessReports = canAccessPath('/operator/reports');

    //for handling mobile and desktop versions of these pages
    const isOperatorRoot = loc.pathname === `/operator`;
    const [menuClassName, contentClassName] = isOperatorRoot ? ["", "d-none"] : ["d-none", ""];
    const activeOverride = loc.pathname === `/operator` || loc.pathname === `/operator/dashboard`;

    return <Container fluid className="fullheight pt-2">
        <div className="d-flex fullheight">
            <CollapsibleSidebar 
                className={menuClassName}
                header={
                    <PageTitle className="fw-bold text-center">
                        {operator.name}
                    </PageTitle>
                }
            >
                <CollapsibleMenuItem icon={<Buildings   />} to="./facilities"      text="Facilities" />
                {!isFacilityUserOnly && <CollapsibleMenuItem active={activeOverride} default icon={<GraphUp     />} to="./dashboard"       text="Dashboard"       />}
                {canAccessReports && (
                <CollapsibleMenuItem icon={<FileEarmarkBarGraph />} to="./reports"    text="Reports"         />
                )}
                {!isFacilityUserOnly && <CollapsibleMenuItem icon={<People      />} to="./staff"           text="Staff"           />}
                {!isFacilityUserOnly && <CollapsibleMenuItem icon={<Receipt      />} to="./invoices"           text="Invoices"           />}
            </CollapsibleSidebar>
            <div className={`${contentClassName} p-0 m-0 d-md-block fullheight scroll-y-auto flex-fill`}>
                <Outlet />
            </div>
        </div>
    </Container>;
}